import { currency } from 'constant'

export const getFormattedPrice = (price?: number | string | null, toFixed = 2): string =>
  price || price === 0
    ? price.toLocaleString('en-US', { maximumFractionDigits: toFixed, minimumFractionDigits: toFixed })
    : ''

export const getFormattedPriceWithCurrency = (price?: number | string | null, toFixed = 2): string =>
  price || price === 0 ? `${currency}${getFormattedPrice(price, toFixed)}` : '-'
